export function iconTools({ className } = {}) {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 62 61"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M54.6667 60.0833L36.4167 41.8333L43.4167 34.8333L61.6667 53.0833L54.6667 60.0833ZM8.66667 60.0833L1.66667 53.0833L24.6667 30.0833L19 24.4167L16.6667 26.75L12.4167 22.5V29.3333L10.0833 31.6667L0 21.5833L2.33333 19.25H9.16667L5 15.0833L16.8333 3.25C17.9444 2.13889 19.1389 1.33333 20.4167 0.833333C21.6944 0.333333 23 0.0833333 24.3333 0.0833333C25.6667 0.0833333 26.9722 0.333333 28.25 0.833333C29.5278 1.33333 30.7222 2.13889 31.8333 3.25L24.1667 10.9167L28.3333 15.0833L26 17.4167L31.6667 23.0833L39.1667 15.5833C38.9444 14.9722 38.7639 14.3333 38.625 13.6667C38.4861 13 38.4167 12.3333 38.4167 11.6667C38.4167 8.38889 39.5417 5.625 41.7917 3.375C44.0417 1.125 46.8056 0 50.0833 0C50.9167 0 51.7083 0.0833333 52.4583 0.25C53.2083 0.416667 53.9722 0.666667 54.75 1L46.5 9.25L52.5 15.25L60.75 7C61.1389 7.77778 61.4028 8.54167 61.5417 9.29167C61.6806 10.0417 61.75 10.8333 61.75 11.6667C61.75 14.9444 60.625 17.7083 58.375 19.9583C56.125 22.2083 53.3611 23.3333 50.0833 23.3333C49.4167 23.3333 48.75 23.2778 48.0833 23.1667C47.4167 23.0556 46.7778 22.8611 46.1667 22.5833L8.66667 60.0833Z"
        fill="#2F80ED"
      />
    </svg>
  );
}
